import script from "./PopupDeleteAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupDeleteAccount.vue?vue&type=script&setup=true&lang=ts"

import "./PopupDeleteAccount.vue?vue&type=style&index=0&id=9efcfaf8&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9efcfaf8"]])

export default __exports__